import { SxProps } from '@mui/material';

export const PADDING_X = 4;
export const GAP_FLEX_PX = 16;
export const GAP_FALLBACK_PX = 16;
export const COLS = 3;
export const ROWS = 4;

export const ROOT_SX_WITH_GAP: SxProps = {
  flex: '1 1 0px',
  minHeight: 0,
  display: 'flex',
  alignItems: 'stretch',
  flexDirection: 'column',
  gap: `${GAP_FLEX_PX}px`,
  overflow: 'hidden',
};

export const ROOT_SX_FALLBACK: SxProps = {
  'flex': '1 1 0px',
  'minHeight': 0,
  'display': 'flex',
  'alignItems': 'stretch',
  'flexDirection': 'column',
  'overflow': 'hidden',
  '& > * + *': { mt: `${GAP_FALLBACK_PX}px` },
};

export const ROW_SX_WITH_GAP: SxProps = {
  'flex': 1,
  'display': 'flex',
  'flexDirection': 'row',
  'gap': `${GAP_FLEX_PX}px`,
  'overflow': 'hidden',
  '& > *': { flex: '1 1 0px', minWidth: 0 },
};

export const ROW_SX_FALLBACK: SxProps = {
  'flex': 1,
  'display': 'flex',
  'flexDirection': 'row',
  'overflow': 'hidden',
  '& > *': { flex: '1 1 0px', minWidth: 0 },
  '& > * + *': { ml: `${GAP_FALLBACK_PX}px` },
};
